import isEmpty from 'lodash/isEmpty'
import pickBy from 'lodash/pickBy'

export const getAllFiltersSelecteds = (filters) => {
  const arrayFilters = []
  const cleanFiltersObj = pickBy(filters) // remove all keys void
  if (!isEmpty(cleanFiltersObj)) {
    Object.values(filters).forEach((filterSelected) => {
      if (filterSelected) {
        `${filterSelected}`.split('_').forEach((i) => arrayFilters.push(i))
      }
    })
  }
  return arrayFilters
}

export const removeValueFromString = (string = '', value, changeToLowerCase = true) => {
  const stringAsArray = string ? string.toString().split('_') : []
  const index = stringAsArray.indexOf(changeToLowerCase ? value.toLowerCase() : value)
  if (index > -1) {
    stringAsArray.splice(index, 1)
  }
  stringAsArray.sort()
  return stringAsArray.length ? stringAsArray.join('_') : ''
}
